module.exports = __webpack_public_path__ + "media/images/users/facetime-698d8fbc7b22f9fd28df9b798c9a01d4.png";